import { Component, NgZone, OnInit } from '@angular/core';
import { ModalService } from '../../modal.service';
import { MatDialog } from '@angular/material/dialog';
import { FacetecVideoModalComponent } from '@shared/information/modal/facetec-video-modal/facetec-video-modal.component';
import {
  ModalErrorDocumentValidationConfig,
  ModalErrorTextualConfig,
} from '@core/interfaces/modal-error-config.interface';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { DOCUMENT_VALIDATION_CONFIG, DocumentResponse } from './validate-document.config';

@Component({
  selector: 'shell-validate-document',
  templateUrl: './validate-document.component.html',
  styleUrls: ['./validate-document.component.scss'],
})
export class ValidateDocumentComponent implements OnInit {
  config: ModalErrorDocumentValidationConfig;
  code: string = '';
  modalError: any;
  documentResponse = DocumentResponse;

  constructor(
    private modalService: ModalService,
    private dialog: MatDialog,
    private microFrontendRouter: MicroFrontendRouter,
    public messageBusService: MessageBusService,
    public ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.getConfig();
  }

  closeModal() {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalService.close();
      });
    }, 50);
  }

  getConfig() {
    setTimeout(() => {
      this.ngZone.run(() => {
        this.modalError = this.messageBusService.getValue('shell', 'modal.error');
        if (this.modalError && this.modalError.payload && this.modalError.payload.code) {
          this.code = this.modalError.payload.code;
          this.config = DOCUMENT_VALIDATION_CONFIG.get(
            this.modalError.payload.code,
          ) as ModalErrorDocumentValidationConfig;
        }
      });
    }, 50);
  }
}
